{
  "04d731014d48596136528ea70cc4b5d3": {
    "width": 848,
    "height": 480
  },
  "08f7868d810d8507ef47eca5570b9687": {
    "width": 848,
    "height": 480
  },
  "0bbf8b248ac873941f81ba95cd6e0d80": {
    "width": 1280,
    "height": 720
  },
  "198f52be38e5b2902bb40a490b779e60": {
    "width": 848,
    "height": 480
  },
  "1d6c7220b2723d245c20dfe43e97fb94": {
    "width": 1280,
    "height": 720
  },
  "1dda04d2896a691f5f85bc3de13ef68a": {
    "width": 1280,
    "height": 720
  },
  "216613c38ea2a8e6b13faa676e877eb1": {
    "width": 608,
    "height": 1080
  },
  "26b115a3c7eab8e832f76f5b93f3a854": {
    "width": 480,
    "height": 848
  },
  "3cf584142e3e285c314f80ff08d3055c": {
    "width": 848,
    "height": 480
  },
  "49563e0c091ec36be68716a923f0d4c7": {
    "width": 1280,
    "height": 720
  },
  "4a3cf31735949a9fe0b17aafe177696b": {
    "width": 848,
    "height": 480
  },
  "4f345bc7081b89d0e52ccfcfbf483fb7": {
    "width": 480,
    "height": 848
  },
  "5290dc94068463025bae133f8aff1edc": {
    "width": 848,
    "height": 480
  },
  "5308f68e6d6d3440078867985e22d503": {
    "width": 848,
    "height": 480
  },
  "58532f0865bbba4909bb4b547eb5146c": {
    "width": 480,
    "height": 848
  },
  "626e421c5d95aa247f05b076de375bb0": {
    "width": 608,
    "height": 1080
  },
  "76ac1a3d3ad03dbd31c773cb3c2ef14c": {
    "width": 848,
    "height": 480
  },
  "7a1e57755e4a40326e904cb74a3bcb6f": {
    "width": 480,
    "height": 848
  },
  "7bdbc2c6222709a0e3e9813aaa6cb78d": {
    "width": 1280,
    "height": 720
  },
  "7c2f553cd2e3984042fcb1b15ae6ee0e": {
    "width": 480,
    "height": 848
  },
  "8a1270729175807b2bc25373eb1e2652": {
    "width": 848,
    "height": 480
  },
  "8e83b1d1bcd019648406f8b1f7877660": {
    "width": 848,
    "height": 480
  },
  "9993d161fd14bc97ed2d9ec5cb2c3b08": {
    "width": 848,
    "height": 480
  },
  "aa44cfd7c78b9802d360086ba80171af": {
    "width": 480,
    "height": 848
  },
  "b08b6191574761e77f6532571654a84c": {
    "width": 848,
    "height": 480
  },
  "be310f1ca03643acf064257ccb38f810": {
    "width": 480,
    "height": 848
  },
  "bedbbc2b782b65b51ffd034cb53ead81": {
    "width": 480,
    "height": 848
  },
  "c3eb29d448259f767ac479a8ca640d9a": {
    "width": 1280,
    "height": 720
  },
  "d039311950e273ea2c43bd447023b9aa": {
    "width": 848,
    "height": 480
  },
  "dbb0c81e666735cb255ae553695cd2b7": {
    "width": 848,
    "height": 480
  },
  "dcdbe3b8926a30d7e1c52c3c48bcc74f": {
    "width": 1280,
    "height": 720
  },
  "e31304e73f3c7b4b8649eec2177a6f2a": {
    "width": 480,
    "height": 848
  },
  "e45782ebfe3caee9fd9c626929adab4f": {
    "width": 480,
    "height": 848
  },
  "e9fcc7a96110a888d291d3a0eb1cadd7": {
    "width": 848,
    "height": 480
  },
  "ef6f51db6cc382422e42bcff104bde93": {
    "width": 480,
    "height": 848
  },
  "ef90d81eceedb9d64df7b9bcc473cdfa": {
    "width": 480,
    "height": 848
  },
  "efd761808f90d969db5e8b1a0c686670": {
    "width": 848,
    "height": 480
  }
}
